import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {setRequestData, getTvCode} from './TvActivationCodeRecoveryBlockSlice';
import {isMobile} from 'react-device-detect';

const CustomerList = (props) => {
   let cssMobile = isMobile ? ' ismobile' : '';

  const onClickHandler = async (item) => {
    try {
        const res = await props.getTvCode(item.ban);
        if (res && res.payload.tvParameters && res.payload.tvParameters.tvCode && res.payload.tvParameters.tvEmail) {  
          props.setRequestData(item);
        };
    } catch (error) {
        console.error("שגיאה בקבלת הנתונים:", error);
    };
};
        
  return (
    <div className='tv-customer-list'>
      {isMobile ? (
        <div className={'caption' + cssMobile}>
          <div>רק רגע,</div>
          <div>אנחנו רואים שיש לך כמה שירותי {window.Config.brand_Name_HE} TV</div>
        </div>
      ) : (
        <div className='caption'>
          <div>רק רגע, אנחנו רואים שיש לך כמה שירותי {window.Config.brand_Name_HE} TV</div>
        </div>
      )}

      <div className='customer-list'>
        <div className='list-title'>על איזה מהם אנחנו מדברים?</div>
        {props.customerList.map((item, index) => {
          return (
            <div
              className='customer-info'
              key={index}
              role='button'
              tabIndex={index}
              onKeyPress={(e) => Helper.onKeyPress(e, props.setRequestData(item))}
              onClick={() => onClickHandler(item)}>
              <div className='customer-info-content'>
                <div className='arrow'></div>
                <div className='info'>
                  <div className='info-title'>שרות {window.Config.brand_Name_HE} TV</div>
                  <div className='email'>{item.username}</div>
                  <div className='address'>{item.address}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    customerList: state.TvActivationCodeRecovery.customerList,
    selectedCustomer: state.TvActivationCodeRecovery.selectedCustomer,
  };
};

const mapDispatchToProps = {
  setRequestData,
  getTvCode
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);
